import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";

import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { DayjsUtils } from "src/libs/dayjs-utils";
import { replaceString } from "src/libs/replace-string";
import { VehiclesEndpoints } from "src/containers/vehicles/constants/endpoints";

@injectable()
export class VehiclesRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getTracking(
        userIdentity: string,
        systemCode: string,
        policyId: number,
        dateRange: string = DayjsUtils.today().format("YYYY-MM-DD")
    ): Observable<Array<object>> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            userIdentity,
            "MEP"
        );
        const url = replaceString(VehiclesEndpoints.GetTracking, {
            ":userIdentity": userIdentity,
            ":policyId": policyId,
        });
        return this.http.getJSON<Array<Record<string, any>>>(url, {
            isPublicRequest: false,
            params: { "system-code": systemCode, "query-dates": dateRange },
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }

    @autoBind
    getFirstVehicle(
        userIdentity: string,
        systemCode: string,
        policyId: number
    ): Observable<object> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            userIdentity,
            "MEP"
        );
        const url = replaceString(VehiclesEndpoints.GetVehicle, {
            ":userIdentity": userIdentity,
            ":policyId": policyId,
        });
        return this.http.getJSON<Array<Record<string, any>>>(url, {
            isPublicRequest: false,
            params: { "system-code": systemCode },
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }
}
